import { useCallback } from 'react';
import { ScheduleSlotProvider } from '../useScheduleSlotContext';

export interface IScheduleSlotRootProps {
  children?: React.ReactNode;
  disciplineSlug: string;
  compact?: boolean;
  selected?: boolean;
  currentProgress?: number;
  totalProgress?: number;
  className?: string;
  type?: 'summary' | 'default';
  onClick?: () => void;
}

export function ScheduleSlotRoot({
  children,
  disciplineSlug,
  compact = false,
  selected = false,
  currentProgress = 0,
  totalProgress = 100,
  className = '',
  type = 'default',
  onClick,
}: IScheduleSlotRootProps) {
  const getDisciplineColor = useCallback(() => {
    if (disciplineSlug === 'simulado')
      return {
        bg: 'bg-mono-color-lighter',
        border: 'border-brand-color-primary-lighter',
        colorSelected: '!bg-brand-color-primary-lighter',
      };

    return {
      bg: `bg-disciplina-${disciplineSlug}`,
      border: `border-disciplina-${disciplineSlug}`,
    };
  }, [disciplineSlug]);

  const { bg, border, colorSelected } = getDisciplineColor();

  return (
    <ScheduleSlotProvider
      disciplineSlug={disciplineSlug}
      compact={compact}
      selected={selected}
      currentProgress={currentProgress}
      totalProgress={totalProgress}
      type={type}
    >
      <div
        className={`flex rounded-md ${bg} min-w-fit ${compact ? 'grow' : 'w-full'} ${className}`}
        onClick={onClick}
      >
        <div
          className={`
          flex
          justify-between
          gap-[6px]
          rounded-sm
          bg-mono-color-white
          ${compact ? `grow items-center p-1` : 'w-full flex-col px-2 py-1'}
          ${selected && !colorSelected ? 'bg-opacity-0' : 'bg-opacity-80'}
          ${selected && colorSelected ? colorSelected : ''}
          ${!selected && `cursor-pointer ${colorSelected ? 'hover:bg-color-lighter' : 'hover:bg-opacity-70'}`}
          ${border}
          ${type === 'summary' ? '!p-4' : ''}
          ${className}
        `}
        >
          {children}
        </div>
      </div>
    </ScheduleSlotProvider>
  );
}
